import { render, staticRenderFns } from "./LoadingDialogComponent.vue?vue&type=template&id=644cba10&"
import script from "./LoadingDialogComponent.vue?vue&type=script&lang=js&"
export * from "./LoadingDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDialogComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QSpace,QSpinnerDots,QBtn});
